import { useState } from "react";
import { Button, Modal } from "antd";

import paperShredder from "../../assets/images/webToLead/paper-shredder.svg";

const RemoveAccount = ({ onRemove }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Button className="stop-sync" onClick={() => showModal()}>
        Remove Account
      </Button>
      <Modal
        title={
          <div
            className="heading24px text-color-1C1C1C roboto-medium"
            style={{ padding: "20px 24px 10px" }}
          >
            Remove Account
          </div>
        }
        className="delete-popup"
        open={isModalOpen}
        centered
        footer={null}
        onOk={handleCancel}
        onCancel={handleCancel}
      >
        <div
          style={{ padding: "0 24px 20px 24px" }}
          className="web-to-lead mt10"
        >
          <div
            className="d-flex align-items-center"
            style={{ gap: 50, margin: "0 24px 20px 24px" }}
          >
            <img src={paperShredder} alt="" />
            <div className="text-color-434040 heading16px mt10">
              <div>Are you sure you want to remove account?</div>
              <div className="mt10">
                Removing your email account will halt all future email tracking
                and synchronization.
              </div>
            </div>
          </div>
          <div
            className="mt40 d-flex justify-content-end align-items-center"
            style={{ gap: 20 }}
          >
            <Button className="secondary-btn" onClick={handleCancel}>
              Cancel
            </Button>
            <Button
              type="primary"
              className="theme-btn"
              onClick={() => {
                onRemove();
                handleCancel();
              }}
            >
              Remove
            </Button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default RemoveAccount;
